if (window.__prLandingInit) { /* already initialized */ } else {
  window.__prLandingInit = true;
document.addEventListener("DOMContentLoaded", () => {

});
document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll(".pr-marquee").forEach((marquee)=>{

        const track = marquee.querySelector(".pr-marquee-track");

        if(!track) return;

        marquee.addEventListener("mouseenter",()=>{

            track.style.animationPlayState="paused";

        });

        marquee.addEventListener("mouseleave",()=>{

            track.style.animationPlayState="running";

        });

    });

});
/* =====================================================
   PR Testimonials
===================================================== */

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.pr-testimonial-slider').forEach((slider) => {

    const track = slider.querySelector('.pr-testimonial-track');

    if (!track) return;

    /* -----------------------------
       Reduced Motion
    ------------------------------ */

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      track.style.animation = 'none';
      return;
    }

    /* -----------------------------
       Pause when tab hidden
    ------------------------------ */

    document.addEventListener('visibilitychange', () => {

      if (document.hidden) {
        track.style.animationPlayState = 'paused';
      } else {
        track.style.animationPlayState = 'running';
      }

    });

    /* -----------------------------
       Mouse Hover
    ------------------------------ */

    slider.addEventListener('mouseenter', () => {
      track.style.animationPlayState = 'paused';
    });

    slider.addEventListener('mouseleave', () => {
      track.style.animationPlayState = 'running';
    });

    /* -----------------------------
       Touch Drag
    ------------------------------ */

    let startX = 0;
    let dragging = false;

    slider.addEventListener('touchstart', (e) => {

      dragging = true;

      startX = e.touches[0].clientX;

      track.style.animationPlayState = 'paused';

    }, { passive: true });

    slider.addEventListener('touchmove', (e) => {

      if (!dragging) return;

      const currentX = e.touches[0].clientX;

      const diff = currentX - startX;

      track.style.transform = `translateX(${diff}px)`;

    }, { passive: true });

    slider.addEventListener('touchend', () => {

      dragging = false;

      track.style.transform = '';

      track.style.animationPlayState = 'running';

    });

  });

});
/*==================================================
  PR FAQ Accordion
==================================================*/

document.addEventListener('DOMContentLoaded', () => {

  const faqSections = document.querySelectorAll('.pr-faq');

  faqSections.forEach((section) => {

    const items = section.querySelectorAll('.pr-faq-item');

    if (!items.length) return;

    /* -----------------------------
       Open first item
    ----------------------------- */

    items.forEach((item) => {

      const answer = item.querySelector('.pr-faq-answer');

      if (item.classList.contains('is-open')) {

        answer.style.display = 'block';
        answer.style.maxHeight = answer.scrollHeight + 'px';

      } else {

        answer.style.display = 'none';
        answer.style.maxHeight = '0px';

      }

    });

    /* -----------------------------
       Click
    ----------------------------- */

    items.forEach((item) => {

      const question = item.querySelector('.pr-faq-question');
      const answer = item.querySelector('.pr-faq-answer');

      question.addEventListener('click', () => {

        const isOpen = item.classList.contains('is-open');

        /* Close all */

        items.forEach((other) => {

          const otherAnswer = other.querySelector('.pr-faq-answer');
          const otherButton = other.querySelector('.pr-faq-question');

          other.classList.remove('is-open');

          otherButton.setAttribute('aria-expanded', 'false');

          otherAnswer.style.maxHeight = '150px';

          setTimeout(() => {

            if (!other.classList.contains('is-open')) {
              otherAnswer.style.display = 'none';
            }

          }, 300);

        });

        /* Open clicked */

        if (!isOpen) {

          item.classList.add('is-open');

          question.setAttribute('aria-expanded', 'true');

          answer.style.display = 'block';

          requestAnimationFrame(() => {

            answer.style.maxHeight = answer.scrollHeight + 'px';

          });

        }

      });

    });

  });

});

document.addEventListener("DOMContentLoaded",()=>{

const cards=document.querySelectorAll(".pr-problem-card");

const observer=new IntersectionObserver(entries=>{

entries.forEach(entry=>{

if(entry.isIntersecting){

entry.target.classList.add("is-visible");

}

});

},{threshold:.15});

cards.forEach(card=>observer.observe(card));

});

document.addEventListener("DOMContentLoaded",()=>{

const cards=document.querySelectorAll(".pr-exchange-card");

const observer=new IntersectionObserver(entries=>{

entries.forEach(entry=>{

if(entry.isIntersecting){

entry.target.classList.add("show");

}

});

},{threshold:.15});

cards.forEach(card=>observer.observe(card));

});
}